<script setup lang="ts">
const client = useStrapi()
const { locale } = useI18n()

const {
  data: result,
  status,
  error
} = await useAsyncData(
  'footer',
  async () =>
    await client.single('footer').find({
      populate: ['nav', 'nav.children'],
      locale: locale.value
    }),
  {
    watch: [locale]
  }
)
</script>

<template>
  <LazyTheSubscriptionSection />

  <section class="dark bg-stone-950 pt-12">
    <UFooter>
      <template #top>
        <UContainer
          class="flex flex-col lg:flex-row gap-12 sm:gap-24 lg:gap-38 items-start justify-between"
        >
          <div class="flex justify-center flex-shrink-0 w-full lg:w-auto">
            <NuxtLinkLocale :to="{ name: 'index' }">
              <NuxtImg
                src="/images/logo-lg.webp"
                alt=""
                aria-hidden="true"
                role="presentation"
                lazy
                width="180"
                class="grid-cols-1"
              />
            </NuxtLinkLocale>
          </div>

          <div class="w-full" v-if="status === 'success'">
            <UFooterColumns
              :columns="result?.data?.nav"
              :ui="{
                root: 'xl:grid-cols-1',
                center: 'md:grid',
                label:
                  'text-center md:text-left text-base uppercase text-stone-200 w-full',
                link: 'text-[15px] hover:underline',
                list: 'space-y-5',
                linkLabel: 'w-full text-center md:text-left'
              }"
            />
          </div>
        </UContainer>
      </template>
    </UFooter>

    <USeparator class="h-px"></USeparator>

    <UFooter>
      <template #left>
        <NuxtLinkLocale to="/support/copyright" class="text-sm"
          >Copyright © {{ new Date().getFullYear() }} Eleven Spectacles. All
          rights reserved.
        </NuxtLinkLocale>
      </template>
    </UFooter>
  </section>
</template>
